import React from 'react';
import { Badge } from '@/components/ui/badge';

// Explicación de los estados de un proceso terapéutico (process_patient.status).
// Fuente única compartida por el panel lateral de "Tasa de inactividad"
// (MetricsInactividadTab, vista 'proceso') y el modal de la columna "Estado"
// en la vista de pacientes (PatientTable). Los colores de los badges deben
// coincidir con los de PatientTable.statusBadge.

export const ProcessStatesInfo: React.FC = () => (
  <div className="flex flex-col gap-4 text-sm text-gray-700 leading-relaxed">
    <p>
      Cada vez que empezás a atender a un paciente con un tipo de terapia, se abre un <strong>proceso terapéutico</strong>.
      Es la relación terapéutica entre vos y ese paciente — la combinación de psicóloga + paciente + tipo de terapia (individual, pareja, familia, etc).
    </p>
    <p className="text-gray-500">
      Un proceso que pasa a <strong>inactivo</strong> puede ser reactivado: si el paciente retoma las sesiones,
      el proceso vuelve a estado <strong>activo</strong> automáticamente.
    </p>
    <div className="border-t border-gray-100 pt-4">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Estados de un proceso</p>
      <div className="rounded-xl border border-gray-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left px-4 py-2.5 font-semibold text-gray-600 text-xs">Estado</th>
              <th className="text-left px-4 py-2.5 font-semibold text-gray-600 text-xs">Descripción</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            <tr>
              <td className="px-4 py-3 whitespace-nowrap"><Badge className="bg-cyan-100 text-cyan-700 text-xs font-medium">Nuevo</Badge></td>
              <td className="px-4 py-3 text-gray-600">El paciente fue asignado a vos pero aún no tuvo su primera sesión.</td>
            </tr>
            <tr>
              <td className="px-4 py-3 whitespace-nowrap"><Badge className="bg-emerald-100 text-emerald-700 text-xs font-medium">Activo</Badge></td>
              <td className="px-4 py-3 text-gray-600">Tuvo sesión en los últimos 30 días.</td>
            </tr>
            <tr>
              <td className="px-4 py-3 whitespace-nowrap"><Badge className="bg-amber-100 text-amber-700 text-xs font-medium">En pausa</Badge></td>
              <td className="px-4 py-3 text-gray-600">Pausado temporalmente: derivación iniciada, alta terapéutica, o el paciente pidió pausar.</td>
            </tr>
            <tr>
              <td className="px-4 py-3 whitespace-nowrap"><Badge className="bg-red-100 text-red-700 text-xs font-medium">Inactivo</Badge></td>
              <td className="px-4 py-3 text-gray-600">Pasaron 30 días desde la última sesión.</td>
            </tr>
            <tr>
              <td className="px-4 py-3 whitespace-nowrap"><Badge className="bg-blue-100 text-blue-700 text-xs font-medium">Derivación exitosa</Badge></td>
              <td className="px-4 py-3 text-gray-600">El paciente comenzó con su nuevo terapeuta dentro de los 30 días de iniciada su derivación interna. No cuenta como baja en tu tasa de inactividad.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ProcessStatesInfo;
